import { render, staticRenderFns } from "./Leaf.vue?vue&type=template&id=304ddf42&"
import script from "./Leaf.vue?vue&type=script&lang=js&"
export * from "./Leaf.vue?vue&type=script&lang=js&"
import style0 from "./Leaf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports